import { gbp0, pct, pctTone, varTone } from "./reportFormat";

const th = "px-3 py-2 text-right font-semibold text-[11px] text-slate-600";
const td = "px-3 py-1.5 text-right font-mono tabular-nums whitespace-nowrap";

// The sheet's Summary tab — month × (Loan Due, Cash, %, Variance) + year total. Click a month to open it.
export function ReportSummary({ data, onOpenMonth }) {
  const months = data?.months || [];
  const t = data?.total || {};
  const curMonth = Number((data?.today || "").slice(5, 7));
  return (
    <div className="rounded-lg border border-slate-200 bg-white shadow-sm overflow-hidden" data-testid="report-summary">
      <table className="w-full text-sm">
        <thead>
          <tr className="bg-slate-50 border-b border-slate-200">
            <th className={`${th} text-left`}>{data?.year}</th><th className={th}>Loan Due</th><th className={th}>Cash Collection</th><th className={th}>Collection %</th><th className={th}>Variance</th><th className={th}>Days</th>
          </tr>
        </thead>
        <tbody>
          {months.map((m) => (
            <tr key={m.month} className={`border-b border-slate-100 ${m.has_data ? "hover:bg-sky-50 cursor-pointer" : "text-slate-300"} ${m.month === curMonth ? "bg-emerald-50/50" : ""}`}
                onClick={() => m.has_data && onOpenMonth(m.month)} data-testid={`summary-row-${m.month}`}>
              <td className="px-3 py-1.5 font-medium">{m.month_name}{m.month === curMonth && <span className="ml-2 text-[10px] font-semibold text-emerald-700">live</span>}</td>
              <td className={td}>{m.has_data ? gbp0(m.loan_due) : "—"}</td>
              <td className={td}>{m.has_data ? gbp0(m.cash_collected) : "—"}</td>
              <td className={`${td} font-semibold ${m.has_data ? pctTone(m.collection_pct) : ""}`}>{m.has_data ? pct(m.collection_pct) : "—"}</td>
              <td className={`${td} ${m.has_data ? varTone(m.variance) : ""}`}>{m.has_data ? gbp0(m.variance) : "—"}</td>
              <td className={`${td} text-slate-400`}>{m.has_data ? m.days : ""}</td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-slate-900 text-white" data-testid="summary-total">
            <td className="px-3 py-2 font-semibold">Total</td>
            <td className={td}>{gbp0(t.loan_due)}</td><td className={td}>{gbp0(t.cash_collected)}</td>
            <td className={`${td} font-semibold ${t.collection_pct < 100 ? "text-rose-300" : "text-emerald-300"}`}>{pct(t.collection_pct)}</td>
            <td className={`${td} ${t.variance < 0 ? "text-rose-300" : "text-emerald-300"}`}>{gbp0(t.variance)}</td>
            <td className={`${td} text-slate-400`}>{t.days}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
